<template>
  <v-container v-if="show" fluid>
    <v-row style="margin-bottom: 10px;" v-if="disabledByStatus">
      <v-spacer></v-spacer>
      <v-btn color="info" @click="openNewSignerModal">
        Novo Signatário
      </v-btn>
    </v-row>

    <v-divider v-if="disabledByStatus"></v-divider>

    <v-data-table
        :headers="headers"
        :items="signers"
        class="has-documents"
        no-data-text="Sem signatários para exibir!">

      <template v-slot:item.attributes.name="{ item }">
        {{ wrapFilename(item.attributes.name) }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="td-action">
          <v-btn @click="viewSigner(item)">
            <v-icon color="blue" small>
              mdi-eye
            </v-icon>
          </v-btn>

          <v-btn @click="confirmDelete(item)" v-if="disabledByStatus">
            <v-icon color="error" small>
              mdi-delete
            </v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="signerModal" persistent width="1000px">
      <v-card>
        <v-toolbar color="primary" dark style="position: sticky;
                          top: 0;
                          z-index: 1000;">
          <v-btn :disabled="isLoadingSigner" dark icon @click="closeSignerModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ signerTitleModal }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="disabledByStatus" :disabled="isLoadingSigner" text @click="saveSigner">
            Salvar
          </v-btn>
          <v-dialog v-model="isLoadingSigner" max-width="400" persistent>
            <v-list class="py-5" color="primary" elevation="12" rounded>
              <v-list-item class="d-flex justify-space-between">
                <div>
                  <span style="color: white; font-size: large;">Salvando Signatário</span>
                </div>
                <div>
                  <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                </div>
              </v-list-item>
            </v-list>
          </v-dialog>
        </v-toolbar>

        <v-dialog v-model="selectRoleAndAuthModal" max-width="800px" persistent>
          <v-card>
            <v-toolbar color="primary" dark style="position: sticky;
                          top: 0;
                          z-index: 1000;">
              <v-btn :disabled="isLoadingSigner" dark icon @click="() => selectRoleAndAuthModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Associar Documento</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn :disabled="isLoadingSigner" text @click="saveRoleAndAuth">
                Salvar
              </v-btn>
              <v-dialog v-model="isLoadingSigner" max-width="400" persistent>
                <v-list class="py-5" color="primary" elevation="12" rounded>
                  <v-list-item class="d-flex justify-space-between">
                    <div>
                      <span style="color: white; font-size: large;">Salvando...</span>
                    </div>
                    <div>
                      <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                    </div>
                  </v-list-item>
                </v-list>
              </v-dialog>
            </v-toolbar>

            <v-card-text>
              <v-row cols="12" class="mt-4">
                <v-col>
                  <span style="font-size: 20px;">
                    Selecione a forma de <strong> autenticação </strong> e a <strong> função de assinatura </strong> para o arquivo: <strong> {{ newRoleAndAuth.document_filename }} </strong>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <v-autocomplete
                      v-model="newRoleAndAuth.authenticate_with"
                      :items="authenticateWithOptions"
                      item-text="text"
                      item-value="value"
                      label="Autenticação"
                      outlined
                  />
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                      v-model="newRoleAndAuth.sign_as"
                      :items="signAsOptions"
                      item-text="text"
                      item-value="value"
                      label="Assinará Como"
                      outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>

          </v-card>
        </v-dialog>

        <v-card-text>
          <v-form ref="form" v-model="validFormSigner">
            <v-row cols="12">
              <v-col cols="8">
                <v-text-field
                    v-model="signer.name"
                    :readonly="isView"
                    :rules="ruleRequired"
                    label="Nome Completo *"
                    outlined
                />
              </v-col>

              <v-col cols="4">
                <v-text-field
                    v-model="signer.email"
                    :readonly="isView"
                    label="Email"
                    :rules="ruleEmail"
                    outlined
                />
              </v-col>
            </v-row>

            <v-row class="negative-mt-30" cols="12">
              <v-col cols="4">
                <v-text-field
                    v-model="signer.documentation"
                    v-mask="'###.###.###-##'"
                    :aria-required="signer.has_documentation"
                    :disabled="isLoadingSigner || !signer.has_documentation"
                    :readonly="isView"
                    label="CPF"
                    outlined/>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="signer.birthday"
                    v-mask="'##/##/####'"
                    :aria-required="signer.has_documentation"
                    :disabled="isLoadingSigner || !signer.has_documentation"
                    :readonly="isView"
                    label="Data de Nascimento"
                    outlined/>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="signer.phone_number"
                    v-mask="'(##) #####-####'"
                    :readonly="isView"
                    label="Telefone"
                    outlined
                />
              </v-col>
            </v-row>

            <v-row class="negative-mt-50">
              <v-col>
                <v-row cols="6">
                  <v-checkbox :disabled="isView" v-model="signer.has_documentation" label="Solicitar CPF ao signatário"></v-checkbox>
                </v-row>

                <v-row class="negative-mt-30" cols="6">
                  <v-checkbox :disabled="isView" v-model="signer.refusable" label="Signatário pode recusar a assinatura?"></v-checkbox>
                </v-row>

                <v-row class="negative-mt-30" cols="6">
                  <v-checkbox :disabled="isView" v-model="signer.location_required_enabled"
                              label="Solicitar Localização no momento da Assinatura"></v-checkbox>
                </v-row>
              </v-col>
            </v-row>

            <v-row cols="12">
              <v-col class="negative-mt-30">
                <v-card>
                  <v-card-title class="clickable" @click="() => this.expandSelectedDocuments = !this.expandSelectedDocuments">
                    Documentos Selecionados
                    <v-spacer/>
                    <v-icon right>{{ expandSelectedDocuments ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-card-title>
                  <v-expand-transition>
                    <v-card-text v-show="expandSelectedDocuments">
                      <v-data-table :headers="documentsSelected" :items="signer.requirements">
                        <template v-slot:item.actions="{ item }">
                          <div class="td-action">
                            <v-btn @click="deleteSelectedDocument(item)" v-if="disabledByStatus">
                              <v-icon color="error">
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </div>
                        </template>

                        <template v-slot:item.sign_as="{ item }">
                          <div class="td-action">
                            {{ signAsOptions.find(opt => opt.value === item.sign_as).text }}
                          </div>
                        </template>

                        <template v-slot:item.authenticate_with="{ item }">
                          <div class="td-action">
                            {{ authenticateWithOptions.find(opt => opt.value === item.authenticate_with).text }}
                          </div>
                        </template>

                      </v-data-table>
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>

            <v-row cols="12">
              <v-col cols="12">
                <v-card>
                  <v-card-title class="clickable" @click="() => this.expandDocuments = !this.expandDocuments">
                    Documentos
                    <v-spacer/>
                    <v-icon right>{{ expandDocuments ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-card-title>
                  <v-expand-transition>
                    <v-card-text v-show="expandDocuments">
                      <v-data-table :headers="documentHeaders" :items="documents">
                        <template v-slot:item.actions="{ item }">
                          <div class="td-action">
                            <v-btn @click="openSelectRoleAndAuthModal(item)" v-if="disabledByStatus">
                              <v-icon color="success">
                                mdi-plus
                              </v-icon>
                            </v-btn>
                          </div>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-expand-transition>

                </v-card>
              </v-col>
            </v-row>

            <v-row cols="12">
              <v-col class="">
                <v-card>
                  <v-card-title class="clickable" @click="() => this.expandNotification = !this.expandNotification">
                    Notificações
                    <v-spacer/>
                    <v-icon right>{{ expandNotification ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                  </v-card-title>
                  <v-expand-transition>
                    <v-card-text v-show="expandNotification">
                      <div v-for="(option, index) in communicateOptions" :key="index">
                        <label>{{ option.displayText }}</label>
                        <v-select
                            :readonly="isView"
                            v-model="signer.communicate_events[Object.keys(option)[1]]"
                            :items="option[Object.keys(option)[1]]"
                            item-text="text"
                            item-value="value"
                            outlined
                        ></v-select>
                      </div>
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>

          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import Signers from "./SignersScripts.js";

export default Signers;
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.negative-mt-10 {
  margin-top: -10px;
}

.negative-mt-20 {
  margin-top: -20px;
}

.negative-mt-30 {
  margin-top: -30px;
}

.negative-mt-40 {
  margin-top: -40px;
}

.negative-mt-50 {
  margin-top: -50px;
}

.has-documents {
  margin-top: 20px;
  height: 600px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.td-action {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}

.positive-mt-10 {
  margin-top: 10px;
}
</style>